export default "__VITE_ASSET__BoEU9ixz__"